<script lang="ts">
	import DropdownMenu from '../../dropdown/SimpleDropdownMenu.svelte'
	import SimpleDropdownLinkItem from '../../dropdown/SimpleDropdownLinkItem.svelte'
	import DropdownMenuSection from '../../dropdown/DropdownMenuSection.svelte'
	import MenuItem from '../../MenuItem.svelte'
	import TagBeta from '#lib/atoms/TagBeta.svelte'
	import { UserPermission } from '../../../types/enums'
	import { t } from '../../../../i18n/i18n'

	// Das Menü erscheint, sobald der Nutzer das normale Dashboard, das (MM-)AI-Dashboard
	// ODER die eingebettete SaaS-Sicht sehen darf — so findet auch ein reiner AI- bzw.
	// SaaS-Nutzer den Einstieg über dieses Menü.
	const DASHBOARD_PERMISSIONS = `${UserPermission.DASHBOARD} | ${UserPermission.VIEW_AI_DASHBOARD} | ${UserPermission.SHOW_AI_DASHBOARD}`
</script>

<MenuItem
	title={$t('Dashboard.title')}
	url="/dashboard"
	permissions={DASHBOARD_PERMISSIONS}
	let:active
>
	<DropdownMenu {active}>
		<DropdownMenuSection>
			<SimpleDropdownLinkItem
				titleKey="Dashboard.title"
				url="/dashboard"
				permissions={UserPermission.DASHBOARD}
			/>
			<!-- FIXME: reduce to a single item with conditional props -->
			<SimpleDropdownLinkItem
				titleKey="AiDashboard.title"
				url="/ai-dashboard"
				permissions={UserPermission.VIEW_AI_DASHBOARD}
				isExternal
			>
				{#snippet tag()}
					<TagBeta />
				{/snippet}</SimpleDropdownLinkItem
			>
			<!-- SaaS-Mandanten: eingebettete SaaS-Sicht (eigenes Unternehmen, ohne Dashboard-Menü) -->
			<SimpleDropdownLinkItem
				titleKey="AiDashboard.title"
				url="/saas-dashboard"
				permissions={UserPermission.SHOW_AI_DASHBOARD}
				isExternal
			>
				{#snippet tag()}
					<TagBeta />
				{/snippet}
			</SimpleDropdownLinkItem>
		</DropdownMenuSection>
	</DropdownMenu>
</MenuItem>
